import { Col, Grid, RowWrap } from "@govlaunch/core";
import React from "react";
import { ISelfieQuery } from "~/lib/queries/__generated__/SelfieQuery.generated";
import { IVendorQuery } from "~/lib/queries/__generated__/VendorQuery.generated";
import ChangePlans from "~/components/makers/ChangePlans";
import CompanyAccountBillingInfo from "~/components/makers/CompanyAccountBillingInfo";
import FullVendorProjects from "~/components/project/FullVendorProjects";
import EditVendorForm from "~/components/vendor/form/EditVendorForm";
import VendorGovernmentConnections from "~/components/vendor/tabs/VendorGovernmentConnections";
import VendorStories from "~/components/vendor/VendorStories";
import EditVendorGroup from "~/components/vendor/profile/EditVendorGroup";
import NewVendorGroup from "~/components/vendor/profile/NewVendorGroup";
import VendorActions from "~/components/vendor/profile/VendorActions";
import VendorGroups from "~/components/vendor/profile/VendorGroups";
import VendorTeam from "~/components/vendor/profile/VendorTeam";
import VendorOwnerFeedTab from "~/components/vendor/profile/owner/tabs/VendorOwnerFeedTab";
import VendorOwnerProductsTab from "~/components/vendor/profile/owner/tabs/VendorOwnerProductsTab";
import VendorOwnerSharingTab from "~/components/vendor/profile/owner/tabs/VendorOwnerSharingTab";
import VendorOwnerSidemenu from "~/components/vendor/profile/owner/VendorOwnerSidemenu";
import UpgradeSuccess from "~/components/makers/UpgradeSuccess";
import VendorInviteGovernments from "~/components/vendor/profile/VendorInviteGovernments";

interface IVendorOwnerProfileProps {
  vendor: IVendorQuery["company"];
  user: ISelfieQuery["selfie"];
  tab: string;
  groupSlug: string | null;
}

export default function VendorOwnerProfile({ vendor, user, tab, groupSlug }: IVendorOwnerProfileProps) {
  if (!vendor) {
    return null;
  }

  return (
    <div
      css={{
        marginTop: 30,
        marginBottom: 30,
        width: "100%",
      }}
    >
      <Grid>
        <RowWrap>
          <Col width={[1, 1, 3 / 12, 3 / 12]}>
            <div
              css={{
                display: "grid",
                gridRowGap: 24,
              }}
            >
              <VendorOwnerSidemenu vendor={vendor} tab={tab} />
            </div>
          </Col>

          <Col width={[1, 1, 9 / 12, 9 / 12]} mt={[24, 24, 0, 0]}>
            {tab === "connect" && <VendorOwnerFeedTab user={user} vendor={vendor} />}
            {tab === "products" && <VendorOwnerProductsTab vendor={vendor} />}
            {tab === "projects" && <FullVendorProjects vendor={vendor} />}
            {tab === "governments" && <VendorGovernmentConnections vendor={vendor} />}
            {tab === "invite-governments" && <VendorInviteGovernments vendor={vendor} />}
            {tab === "stories" && <VendorStories vendor={vendor} />}
            {tab === "groups" && !groupSlug && <VendorGroups vendor={vendor} />}
            {tab === "groups" && groupSlug && <EditVendorGroup groupSlug={groupSlug} vendor={vendor} />}
            {tab === "new-group" && <NewVendorGroup vendor={vendor} />}
            {tab === "actions" && <VendorActions vendor={vendor} />}
            {tab === "sharing" && <VendorOwnerSharingTab vendor={vendor} />}
            {tab === "account" && (
              <div>
                <CompanyAccountBillingInfo vendor={vendor} />
              </div>
            )}
            {tab === "edit-vendor" && <EditVendorForm vendor={vendor} />}
            {tab === "change-plans" && (
              <div>
                <ChangePlans />
              </div>
            )}
            {tab === "preview-profile" && <div>UNDER CONSTRUCTION...</div>}
            {tab === "team" && <VendorTeam vendor={vendor} />}
            {tab === "upgrade-success" && <UpgradeSuccess />}
          </Col>
        </RowWrap>
      </Grid>
    </div>
  );
}
